<template>
  <sub-page :title="title">
    <div class="list-page">
      <div class="list-item" v-for="(item, idx) in items" :key="idx" @click="handleItemClick(item)">
        <img :src="item.icon" class="item-icon" :alt="item.title" />
        <span class="item-text">{{ item.title }}</span>
        <svg viewBox="0 0 24 24" class="arrow-icon"><path d="M9 18 L15 12 L9 6" fill="none" stroke="#c8c9cc" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </div>
    </div>
  </sub-page>
</template>

<script>
import SubPage from './SubPage.vue'

export default {
  name: 'OneThing',
  components: { SubPage },
  data() {
    return {
      title: '一件事专区',
      items: [
        { title: '个人创业一件事', icon: require('@/assets/icons/svc-employ.png') },
        { title: '灵活就业参保一件事', icon: require('@/assets/icons/svc-employ.png') },
        { title: '登记失业人员就业帮扶一件事', icon: require('@/assets/icons/svc-unemploy.png') },
        { title: '退休一件事', icon: require('@/assets/icons/svc-retirement.png') },
        { title: '就业困难认定和补贴一件事', icon: require('@/assets/icons/svc-hardship.png') }
      ]
    }
  },
  methods: {
    handleItemClick(item) {
      this.$router.push('/social-card-query')
    }
  }
}
</script>

<style scoped>
.list-page {
  background: #F3F8FB;
  min-height: 100%;
}
.list-item {
  display: flex;
  align-items: center;
  height: calc(170 * var(--w));
  background: #fff;
  border-bottom: 1px solid #f0f0f0;
  padding: 0 calc(32 * var(--w));
  gap: calc(24 * var(--w));
  cursor: pointer;
}
.list-item:last-child {
  border-bottom: none;
}
.item-icon {
  width: calc(60 * var(--w));
  height: calc(60 * var(--w));
  object-fit: contain;
  flex-shrink: 0;
}
.item-text {
  flex: 1;
  font-size: calc(36 * var(--w));
  color: #323233;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.arrow-icon {
  width: calc(32 * var(--w));
  height: calc(32 * var(--w));
  flex-shrink: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/OneThing.vue